import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthorizationService } from '../../services/authorization.service';
import { Role } from '../../../global/policy-types';
import { PolicyEvent, PolicyService } from '../../services/policy.service';
import { STARTUP_PARAMS, StartupParams } from 'src/app/config/AppInitializer.factory';

@Component({
    selector: 'app-initial-route-resolver',
    template: '<loader></loader>',
    styles: [],
    standalone: false
})
export class InitialRouteResolverComponent implements OnInit, OnDestroy {

  constructor(
    private policyService: PolicyService,
    private authorizationService: AuthorizationService,
    private router: Router,
    @Inject(STARTUP_PARAMS) private _startupQueryParams: StartupParams,
  ) {}

  ngOnInit() {
    this.policyService.events.subscribe(PolicyEvent.PolicyLoaded, this.onPolicyLoaded);
    this.navigateBasedOnRole();
  }

  ngOnDestroy() {
    this.policyService.events.unsubscribe(PolicyEvent.PolicyLoaded, this.onPolicyLoaded);
  }

  private onPolicyLoaded = () => {
    this.navigateBasedOnRole();
  };
  
  private navigateBasedOnRole() {
    // If a destination is specified in the startup query params, then the user is coming 
    // from Partnership Imapct. In this case, app.component.ts will handle the navigation.
    if(this._startupQueryParams.destination){
      return;
    }

    if (this.authorizationService.hasRole(Role.Customer)) {
      this.router.navigate(['/customer-overview']);
    };

    if (this.authorizationService.hasRole(Role.CorporateAccountManager)) {
      this.router.navigateByUrl('/filter');
    }
  }
}
